import api from './api'
export async function loadLabourEnforcement() {
  const [profiles, evaluations, decisions, overrides] = await Promise.all([
    api.get('/api/admin/labour-rules/profiles'), api.get('/api/admin/labour-rules/evaluations'),
    api.get('/api/admin/labour-rules/decisions'), api.get('/api/admin/labour-rules/overrides'),
  ])
  return {profiles: profiles.data.profiles || [], capabilities: profiles.data.capabilities || {},
    evaluations: evaluations.data.evaluations || [], decisions: decisions.data.decisions || [], overrides: overrides.data.overrides || []}
}
export async function approveLabourVersion(profileId: string, versionId: string) {
  await api.post(`/api/admin/labour-rules/profiles/${profileId}/versions/${versionId}/approve`, {state:'approved'})
}
export async function authorizeLabourOverride(decision: any, ruleCode: string, reason: string, idempotencyKey: string) {
  await api.post('/api/admin/labour-rules/override-authorizations', {profileVersionId:decision.profile_version_id,
    jobShiftId:decision.job_shift_id, workerProfileId:decision.worker_profile_id, ruleCode, reason, idempotencyKey})
}
